import { render } from "./Chooser.vue?vue&type=template&id=158d3f2f"
import script from "./Chooser.vue?vue&type=script&lang=js"
export * from "./Chooser.vue?vue&type=script&lang=js"
script.render = render

export default script